import { Controller } from "@hotwired/stimulus"

// Copy the `source` target's text to the clipboard and flash a "copied" label
// on the button for a moment. Used by the chat's "Copy dialog" button, which
// carries a prebuilt Markdown transcript in a hidden <textarea>.
export default class extends Controller {
  static targets = ["source", "button"]
  static values = { copiedLabel: { type: String, default: "Скопировано" } }

  async copy(event) {
    event.preventDefault()
    // A hidden form field exposes `.value` even when not rendered; other
    // elements use `.innerText`, which is empty under display:none.
    const source = this.sourceTarget
    const text = (source.value ?? source.innerText).trim()

    try {
      await navigator.clipboard.writeText(text)
    } catch {
      // Fallback for non-secure contexts / older browsers.
      const scratch = document.createElement("textarea")
      scratch.value = text
      document.body.appendChild(scratch)
      scratch.select()
      document.execCommand("copy")
      scratch.remove()
    }

    this.#flash()
  }

  #flash() {
    if (!this.hasButtonTarget) return

    const original = this.buttonTarget.dataset.originalLabel || this.buttonTarget.innerText
    this.buttonTarget.dataset.originalLabel = original
    this.buttonTarget.innerText = this.copiedLabelValue
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => { this.buttonTarget.innerText = original }, 1500)
  }
}
